import React from 'react';
import { Result, Button, Card } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { signOut } from '../AuthContext';

const NoAccountMessage: React.FC = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f0f2f5',
    }}
  >
    <Card style={{ maxWidth: 600, width: '90%' }}>
      <Result
        icon={<UserOutlined style={{ color: '#faad14' }} />}
        status='warning'
        title='Account Setup Required'
        subTitle='Welcome! Your account was created but is not yet active. Please contact your administrator to complete setup.'
        extra={[
          <Button type='primary' key='signout' onClick={signOut}>
            Sign Out
          </Button>,
        ]}
      />
    </Card>
  </div>
);

export default NoAccountMessage;
